<ejs-dialog #functionDialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    {{'i18n.domain.parker-registration.adjust-parker-registration-dialog.title' | translate}}
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col-6">
        <ejs-listbox #functionListBox id="functionListBox" [dataSource]="functionsList" [fields]="fieldsDefinition" (change)="listBoxValue($event)">
          <ng-template #itemTemplate let-data>
            {{ data.i18nLabel ?? 'i18n.domain.parker-registration.adjust-parker-registration-dialog.functions.' + data.type |
            translate}}
          </ng-template>
        </ejs-listbox>
      </div>
      <div class="col-6">
        @if (isFunctionSelected(functionType.AdjustStartTime)) {
          <div>
            <app-adjust-start-time-form [adjustStartTimeForm]="adjustStartTimeForm" [parkingSession]="parkingSession">
            </app-adjust-start-time-form>
          </div>
        }
        @if (isFunctionSelected(functionType.AdjustEndTime)) {
          <div>
            <app-adjust-end-time-form [adjustEndTimeForm]="adjustEndTimeForm" [parkingSession]="parkingSession">
            </app-adjust-end-time-form>
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeFunctionDialog()">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button class="btn btn-primary" (click)="applyFunction()" [disabled]="!this.selectedFunction?.form?.valid">
      {{'i18n.domain.parker-registration.adjust-parker-registration-dialog.execute-function-button' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
